// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"IceCreamChallenge_pageWrapper__2BNan","pageContainer":"IceCreamChallenge_pageContainer__3wUmw","pageSection":"IceCreamChallenge_pageSection__3li6O"};